import React from "react";
import { useSelector } from "react-redux";

import { Card, Image, Progress, Button, Icon } from "semantic-ui-react";

import "./BoxItem.css";
import * as Constants from "../../utils/Constants";
import AFrameConstants from "../../lib/aframeboxlookup/Constants";
import classNames from "classnames";
import { ApplicationMode } from "../../lib/store/types/ApplicationStateTypes";
import SkuID from "../SkuID/SkuID";
import ImageWithFallback from "../ImageWithFallback/ImageWithFallback";

const { ActionStates } = AFrameConstants;

const BoxItem = ({
  verifiedQuantity,
  reservedQuantity,
  missingQuantity,
  imageSrc,
  skuID,
  skuIsMissingCallback,
  shelfNumber,
  name,
  skuInputCallback,
  isSingle,
  aframe,
  skuChannels,
  isRx,
  isPaused,
  isAuto,
  isUrgent,
  isBig,
  prefilled,
  showProgress,
  isRxItem,
  rxDisplayBubble = false,
  rxVaruNummer = "",
  isRxMode = false,
  alwaysShowMissing = false,
  dynamicSkuChannels = null,
  isPickExpected = false,
  rxBagClass = "",
  boxID = -1,
  currentRXSortBoxID = -1,
  rxIsNarc = false,
}) => {
  let latestTap;
  const appMode = useSelector((state) => state.applicationStateReducer.appMode);
  const aFrameAction = useSelector((state) => state.aframeModeReducer.aFrameAction);
  showProgress = (isRxMode && currentRXSortBoxID === boxID) || showProgress;

  const doubleTap = (e) => {
    if (appMode === ApplicationMode.AFrameReviewMode && aFrameAction === ActionStates.LOAD_BOX) {
      window.open(`https://la.site.se/article/details?id=${skuID}&idtype=sku`, "_blank");
    } else {
      if (!e.target.classList.contains("orange")) {
        let now = new Date().getTime();
        let timeSince = now - latestTap;
        var timebetweenClicks = 600;

        if (timeSince < timebetweenClicks && timeSince > 0) {
          if (skuInputCallback && typeof skuInputCallback == "function") {
            skuInputCallback("K" + skuID, Constants.SCAN_INPUT_TYPE_SKU, "click");
          } else {
            //console.log("doubleTap!")
          }
        }
        latestTap = now;
      }
    }
  };

  const isReservedOneAndSingle = isSingle && reservedQuantity === 1;

  let classes = classNames({
    ArticleWrapper: true,
    done: verifiedQuantity === reservedQuantity,
    Big: isBig,
    ArticleWrapperAFrame: aframe,
    ArticleWrapperDisabled: !isPickExpected,
    [rxBagClass]: !isRx && isRxMode,
    PrefilledBag: isRx && isRxMode,
  });

  var hidden =
    (verifiedQuantity === reservedQuantity && !isReservedOneAndSingle) ||
    (verifiedQuantity === reservedQuantity && isSingle) ||
    !skuIsMissingCallback ||
    isRx ||
    prefilled > 0 ||
    (!isPaused && isAuto && !isSingle && !isUrgent) ||
    (isRxMode && boxID !== currentRXSortBoxID);

  if (alwaysShowMissing & (skuID < Constants.RX_BAG_SKU)) hidden = false;

  return (
    <Card className={classes}>
      <h3>{name}</h3>
      {rxIsNarc ? (
        <div>
          <span
            style={{
              color: "red",
              float: "left",
              marginTop: "50px",
              position: "absolute",
              zIndex: 3,
            }}
          >
            <b style={{ fontSize: "1.5em" }}>Nark-vara!</b>
          </span>
        </div>
      ) : null}
      <div className="ArticleImageContainer" onClick={isPickExpected ? doubleTap : null}>
        <ImageWithFallback mainSrc={imageSrc} />
        <div className="skuInfo">
          <SkuID skuID={skuID} isRX={isRx} />
          {rxVaruNummer !== null && rxVaruNummer !== "" ? (
            <div>
              <span>
                <b>VNR {rxVaruNummer}</b>
              </span>
            </div>
          ) : null}
        </div>
        {rxDisplayBubble ? (
          <div className="displayBubbleWrapper">
            <Icon
              title="Packa i bubbelplast"
              name={"bold"}
              color={"blue"}
              style={{ margin: "0 auto", display: "block", marginTop: "2px" }}
              size={"large"}
            />
          </div>
        ) : null}
        <Button
          color="orange"
          className={hidden ? "hidden" : ""}
          style={
            isRxMode
              ? { margin: "5px", top: "0px", right: "-1px", height: "40px", position: "absolute" }
              : {}
          }
          onClick={() => skuIsMissingCallback(skuID, shelfNumber)}
        >
          Saknas
        </Button>
      </div>
      {showProgress ? (
        <Card.Content className="CardContentProgressWrapper">
          <div className="flexColumn">
            {/* For RXMode the reserved quantity is shown without subtracting the missing quantity.*/}
            {packBoxItem(verifiedQuantity, reservedQuantity, isRxMode ? 0 : missingQuantity)}
            {isRxMode && missingQuantity > 0 ? missingQuantityNotice(missingQuantity) : null}
            {appMode === ApplicationMode.AFrameReviewMode &&
              aframeBoxItem(skuChannels, skuID, shelfNumber, dynamicSkuChannels, isRxItem)}
            &nbsp;
          </div>
        </Card.Content>
      ) : (
        packBoxItemNoProgressBar(reservedQuantity, isRxMode ? 0 : missingQuantity)
      )}
    </Card>
  );
};

/**
 * Displays notice about missing quantity for RX items.
 */
const missingQuantityNotice = (missingQuantity) => {
  return (
    <div className="MissingQuantityNotice">
      <p>Varav {missingQuantity} st saknades vid plockning</p>
    </div>
  );
};

const aframeBoxItem = (skuChannels, skuID, shelfNumber, dynamicSkuChannels, isRxItem) => {
  if (skuID >= 7000000) {
    return <div className="rxCrate">Back: {shelfNumber}</div>;
  } else if (skuChannels && skuChannels.length === 1 && skuChannels[0].channel === 20039) {
    return <div className="rxCrate">Hylla: {shelfNumber}</div>;
  }
  if (skuChannels && skuChannels.length > 0) {
    var dynamicSkuChannelsForItem = dynamicSkuChannels?.filter(
      (x) => x.skuID == skuID && x.rx == isRxItem
    );
    if (dynamicSkuChannelsForItem && dynamicSkuChannelsForItem.length > 0)
      return dynamicSkuChannelsForItem.map((channel, index) =>
        getChannelItem(channel, index, skuChannels)
      );
    else
      return skuChannels
        .filter((z) => z.shelfNumber == shelfNumber && z.rx == isRxItem)
        .map((channel, index) => getChannelItem(channel, index));
  }
};

const getChannelItem = (itemChannel, index, otherChannelItems = null) => {
  var itemExpectedPick = otherChannelItems?.filter((x) => x.channel === itemChannel.channel);
  if (itemExpectedPick && itemExpectedPick.length > 0 && itemExpectedPick[0]) {
    itemChannel = itemExpectedPick[0];
  }
  return (
    <div key={index} className="ProgressWrapper">
      <span className="ProgressRatioCounter aframe">
        <b>{otherChannelItems != null ? itemChannel.shelfNumber : itemChannel.channel}</b>
      </span>
      <div className="ProgressBarWrapper aframe">
        <Progress
          className="progressBarAFrame"
          size="small"
          value={itemChannel.pickedQuantity}
          total={itemChannel.quantity}
          color={
            itemChannel.pickedQuantity === 0 && itemChannel.quantity !== 0
              ? "red"
              : itemChannel.pickedQuantity < itemChannel.quantity
              ? "yellow"
              : "green"
          }
        />
      </div>
      <span className="ProgressRatioCounter aframe">
        <b>{itemChannel.pickedQuantity + "/" + itemChannel.quantity}</b>
      </span>
    </div>
  );
};

const packBoxItem = (verifiedQuantity, reservedQuantity, missingQuantity) => {
  return (
    <div className="ProgressWrapper">
      {verifiedQuantity === 0 ? (
        <div className="ui grey progress width100 big"></div>
      ) : (
        <div className="ProgressBarWrapper">
          <Progress
            size="medium"
            value={verifiedQuantity}
            total={reservedQuantity - missingQuantity}
            color={verifiedQuantity < reservedQuantity ? "yellow" : "green"}
          />
        </div>
      )}
      <span className="ProgressRatioCounter">
        <b>{verifiedQuantity + "/" + (reservedQuantity - missingQuantity)}</b>
      </span>
    </div>
  );
};

const packBoxItemNoProgressBar = (reservedQuantity, missingQuantity) => {
  return (
    <div className="noProgressBarProgressWrapper">
      <span className="ProgressRatioCounter">
        <b>{reservedQuantity - missingQuantity} st</b>
      </span>
    </div>
  );
};

export default BoxItem;
